<template>
  <v-flex xs12>
    <v-layout row wrap>
      <v-flex xs12 sm6>
        <v-flex class="expandableContainer">
          <v-form lazy-validation @submit.prevent="processForm">
            <v-container>
              <v-layout row wrap>
                <p>
                  {{
                    $t(
                      'configuration.main_school_settings.main_school_information'
                    )
                  }}
                </p>
                <v-flex
                  xs12
                  pa-3
                  class="expandableContainer"
                  style="border-radius: 5px"
                >
                  <v-text-field
                    :error-messages="processErrorName"
                    v-model="brandForm.name"
                    :label="$t('configuration.main_school_settings.name')"
                    required
                  />
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="brandForm.address"
                    :label="$t('configuration.main_school_settings.address')"
                    disabled
                    required
                  />
                </v-flex>
                <v-flex xs12>
                  <v-layout row wrap justify-space-between>
                    <v-flex xs4 sm3>
                      <v-select
                        v-model="flagSelection"
                        :items="flags"
                        hide-details
                        single-line
                        item-value="code"
                      >
                        <template slot="selection" slot-scope="data">
                          <v-list-tile-avatar>
                            <flag :iso="data.item.flag"></flag>
                          </v-list-tile-avatar>
                        </template>
                        <template slot="item" slot-scope="data">
                          <v-list-tile-avatar>
                            <flag :iso="data.item.flag"></flag>
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title>{{
                              data.item.code
                            }}</v-list-tile-title>
                          </v-list-tile-content>
                        </template>
                      </v-select>
                    </v-flex>
                    <v-flex xs8 sm8>
                      <v-text-field
                        :error-messages="processErrorPhone"
                        :prefix="flagSelection"
                        v-model="brandForm.phone"
                        :label="
                          $t('configuration.main_school_settings.phone_number')
                        "
                        mask="(###) ### - ####"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    v-model="brandForm.description"
                    :label="
                      $t('configuration.main_school_settings.description')
                    "
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-flex>
      </v-flex>

      <v-flex xs12 sm6>
        <GmapMap
          ref="mapSettingsBrand"
          :center="{
            lat: brandForm.latitude != null ? brandForm.latitude : 19.702559,
            lng:
              brandForm.longitude != null ? brandForm.longitude : -101.192341,
          }"
          :zoom="19"
          style="height: 473px; margin-top: 3px; border-radius: 15px"
          :options="mapConfig"
        >
          <GmapMarker
            :position="{
              lat: brandForm.latitude != null ? brandForm.latitude : 19.702559,
              lng:
                brandForm.longitude != null ? brandForm.longitude : -101.192341,
            }"
            :draggable="permits['UPDATE_SETTINGS'] ? true : false"
            :icon="google && markerBranchIcon"
            @dragend="brandLocation"
          ></GmapMarker>

          <v-toolbar
            dense
            color="transparent"
            floating
            id="toolbarConfigurationBrand"
            class="titleSearch elevation-0"
          >
            <v-text-field
              class="mx-3 mt-4"
              @keyup.enter="searchName"
              :label="$t('configuration.main_school_settings.search')"
              prepend-inner-icon="search"
              clearable
              solo
              v-model="search"
            ></v-text-field>
          </v-toolbar>
        </GmapMap>
      </v-flex>
      <v-flex>
        <label>
          {{ $t('configuration.main_school_settings.school_address_1') }}
          {{ brandForm.address }} | Latitud: {{ brandForm.latitude }} |
          Longitud: {{ brandForm.longitude }}
        </label>
        <br />
        <label class="red--text">
          {{ $t('configuration.main_school_settings.school_address_2') }}
        </label>
      </v-flex>
    </v-layout>
    <error v-model="toast.error" :text="toast.eMessage"></error>
    <success v-model="toast.success" text="Creación Exitosa"></success>
    <error v-model="toast.failed" :text="toast.fmessage"></error>
  </v-flex>
</template>
<script>
import { mapSettings } from '@/Catalogs/mapSettings'
import { gmapApi } from 'vue2-google-maps'
import { required } from 'vuelidate/lib/validators'
import error from '../../Dialogs/Error'
import success from '../../Dialogs/Success.vue'
export default {
  components: {
    error,
    success,
  },
  validations: {
    brandForm: {
      name: { required },
      address: { required },
      phone: { required },
      latitude: { required },
      longitude: { required },
    },
  },
  props: ['permits', 'save', 'updateDataBrandFromBranch'],
  mounted() {
    this.getBrand()
    var v = this
    this.$refs.mapSettingsBrand.$mapPromise.then((map) => {
      v.map = map
      var input = document.getElementById('toolbarConfigurationBrand')
      var searchBox = new google.maps.places.SearchBox(input)
      map.controls[google.maps.ControlPosition.TOP_CENTER].push(input)
    })
  },
  watch: {
    updateDataBrandFromBranch() {
      if (this.updateDataBrandFromBranch.length === 0) return
      const [newAddress, newLat, newLong] = this.updateDataBrandFromBranch

      this.brandForm.address = newAddress
      this.brandForm.latitude = newLat
      this.brandForm.longitude = newLong
    },
    save() {
      if (this.save) {
        this.processForm()
      }
    },
  },
  data: () => ({
    isBrandSameAsBranch: false,
    brandForm: {
      name: '',
      address: '',
      phone: '',
      latitude: '',
      longitude: '',
      description: '',
      latitude: null,
      longitude: null,
    },
    flagSelection: '+52',
    flags: [
      {
        code: '+52',
        flag: 'mx',
      },
      {
        code: '+1',
        flag: 'us',
      },
    ],
    toast: {
      error: false,
      eMessage: '',
    },
    search: '',
  }),
  methods: {
    processForm() {
      this.$v.brandForm.$touch()
      if (!this.$v.brandForm.$invalid) {
        this.$emit('loading', true)
        this.$store
          .dispatch('brand/updateBrand', this.brandForm)
          .then((response) => {
            this._updateBranchIfHaveNoMoreBranches_BrandIsSameAsBranch()
            this.$emit('loading', false)
            this.$emit('success')
          })
          .catch((error) => {
            this.$emit('loading', false)
            this.$emit('error')
          })
      } else {
        this.$emit('cancel')
      }
    },
    async _updateBranchIfHaveNoMoreBranches_BrandIsSameAsBranch() {
      if (this.isBrandSameAsBranch === false) return

      const branch = {
        address: this.brandForm.address,
        id: this.$store.getters.getBranch.id,
        longitude: this.brandForm.longitude,
        latitude: this.brandForm.latitude,
        markLatitude: this.brandForm.latitude,
        markLongitude: this.brandForm.longitude,
        timezone: '',
        zoom: 15,
      }
      branch.timezone = await this._getTimezone()

      try {
        this.$store.dispatch('branch/updateBranch', branch)
      } catch (error) {
        console.log(error)
      }
    },
    async _getTimezone() {
      try {
        const data = await this.$store.dispatch('timeZoneAPI', {
          latitude: this.brandForm.latitude,
          longitude: this.brandForm.longitude,
        })
        return data.timeZoneId
      } catch (error) {
        console.log(error)
        return ''
      }
    },
    getBrand() {
      this.$store
        .dispatch('brand/getBrand')
        .then((response) => {
          this.isBrandSameAsBranch = response.data.entity.branches.length === 1

          this.brandForm = {
            ...response.data.entity,
            branches: null,
          }

          this.$emit(
            'brandData',
            structuredClone({
              ...this.brandForm,
              isBrandSameAsBranch: this.isBrandSameAsBranch,
            })
          )
        })
        .catch((error) => {
          console.log(error)
        })
    },
    brandLocation(event) {
      this.brandForm.latitude = event.latLng.lat()
      this.brandForm.longitude = event.latLng.lng()
    },
    searchName() {
      var v = this
      var request = {
        query: this.search,
        fields: ['name', 'geometry', 'formatted_address'],
      }
      var service = new google.maps.places.PlacesService(this.map)

      service.findPlaceFromQuery(request, function (results, status) {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          var position = new google.maps.LatLng(
            results[0].geometry.location.lat(),
            results[0].geometry.location.lng()
          )
          v.brandForm.longitude = results[0].geometry.location.lng()
          v.brandForm.latitude = results[0].geometry.location.lat()
          v.brandForm.address = results[0].formatted_address

          v.map.setCenter(position)
          v.map.setZoom(19)
        } else {
          v.toast.eMessage = 'No se encontraron resultados'
          v.toast.error = true
        }
      })
    },
  },
  computed: {
    google: gmapApi,
    mapConfig() {
      return {
        ...mapSettings,
      }
    },
    markerBranchIcon() {
      return {
        url: require('@/assets/mapIcons/if_graduation-cap_3688484.png'),
        scaledSize: new google.maps.Size(48, 48),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(24, 48),
        labelOrigin: new google.maps.Point(24, 0),
      }
    },
    processErrorName() {
      const errors = []
      if (!this.$v.brandForm.name.$dirty) return errors
      !this.$v.brandForm.name.required && errors.push('El nombre es requerido')
      return errors
    },
    processErrorPhone() {
      const errors = []
      if (!this.$v.brandForm.phone.$dirty) return errors
      !this.$v.brandForm.phone.required &&
        errors.push('El teléfono es requerido')
      return errors
    },
  },
}
</script>
<style></style>
